module.exports = __webpack_public_path__ + "static/media/track-cota.a453b0b5.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-cota.png
// module id = 1029
// module chunks = 0